<style lang="scss" scoped>
.box {
  background: $container-bg;
  border: 1px solid $border-color;
  padding: 2.5rem;
  border-radius: $border-radius;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}
@include media-breakpoint-down(sm) {
  .box {
    padding: 1.5rem;
  }
}
</style>

<script>
export default {
  render(createElement) {
    return createElement(
      this.tag,
      {
        class: {
          box: true
        }
      },
      this.$slots.default
    );
  },
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  }
};
</script>
